<template>
  <div class="room ventilation" v-loading="loadingData">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="device-block-multi">
      <div class="air-wrap" :class="warningFlagLeft">
        <div class="air-title">{{ airWrapTitleLeft }}</div>
        <div class="air-chart-wrap">
          <div class="air-chart">
            <single-ring
              :opts="singleRingOpts1"
              :series="singleRingDataLeft1"
            ></single-ring>
          </div>
          <div class="air-chart">
            <single-ring
              :opts="singleRingOpts2"
              :series="singleRingDataLeft2"
            ></single-ring>
          </div>
          <div class="air-chart">
            <single-histogram
              :opts="singleHisOpts"
              :series="singleHisDataLeft"
            ></single-histogram>
          </div>
        </div>
      </div>

      <div class="air-wrap" :class="warningFlagRight">
        <div class="air-title">{{ airWrapTitleRight }}</div>
        <div class="air-chart-wrap">
          <div class="air-chart">
            <single-ring
              :opts="singleRingOpts1"
              :series="singleRingDataRight1"
            ></single-ring>
          </div>
          <div class="air-chart">
            <single-ring
              :opts="singleRingOpts2"
              :series="singleRingDataRight2"
            ></single-ring>
          </div>
          <div class="air-chart">
            <single-histogram
              :opts="singleHisOpts"
              :series="singleHisDataRight"
            ></single-histogram>
          </div>
        </div>
      </div>
    </div>

    <div class="device-block-line">
      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft1"
              :series="switchDataLeft1"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft2"
              :series="switchDataLeft2"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft3"
              :series="switchDataLeft3"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft4"
              :series="switchDataLeft4"
            ></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft5"
              :series="switchDataLeft5"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft6"
              :series="switchDataLeft6"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft7"
              :series="switchDataLeft7"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleLeft8"
              :series="switchDataLeft8"
            ></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="running-time-item-left"
          :title="runningTimeTitleLeft"
          :series="runningTimeDataLeft"
        ></RunningTimeBig>
      </div>

      <div class="device-block-line-item">
        <div class="device-block-line-item-top">
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight1"
              :series="switchDataRight1"
            ></SwitchStatus>
            <!-- <SwitchStatus
              class="switch-item"
              :title="switchTitleRight2"
              :series="switchDataRight2"
            ></SwitchStatus> -->
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight3"
              :series="switchDataRight3"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight4"
              :series="switchDataRight4"
            ></SwitchStatus>
          </div>
          <div class="device-block-line-item-half">
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight5"
              :series="switchDataRight5"
            ></SwitchStatus>
            <!-- <SwitchStatus
              class="switch-item"
              :title="switchTitleRight6"
              :series="switchDataRight6"
            ></SwitchStatus> -->
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight7"
              :series="switchDataRight7"
            ></SwitchStatus>
            <SwitchStatus
              class="switch-item"
              :title="switchTitleRight8"
              :series="switchDataRight8"
            ></SwitchStatus>
          </div>
        </div>
        <RunningTimeBig
          class="running-time-item-right"
          :title="runningTimeTitleRight"
          :series="runningTimeDataRight"
        ></RunningTimeBig>
      </div>
    </div>
  </div>
</template>

<script>
import configJson from './config/stationFlowConfig.json';

export default {
  name: 'ventilationNew',
  data() {
    return {
      timer: null,
      loading: false,
      loadingData: false,

      deviceList: [],
      deviceLeftName: '',
      deviceRightName: '',

      singleRingOpts1: {
        title: '温度&风量',
        labelLineLength: 1,
        center: ['50%', '60%'],
        data1Max: 65,
      },
      singleRingOpts2: {
        title: '压力&频率',
        labelLineLength: 1,
        center: ['50%', '60%'],
        data1Max: 65,
        insideTitle: 'Hz',
        outTitle: 'Pa',
        outTitleSign: '',
      },

      singleHisOpts: {
        title: '湿度',
        histogramName1: 'RH',
        max: 80,
        sign: '%',
      },

      switchTitleLeft1: '上游中效过滤堵塞',
      switchTitleLeft2: '制备站自动运行',
      switchTitleLeft3: '上游送风暂停',
      switchTitleLeft4: '除湿机运行',

      switchTitleLeft5: '上游布袋过滤堵塞',
      switchTitleLeft6: '系统报警',
      switchTitleLeft7: '新风堵塞',
      switchTitleLeft8: '除湿机故障',

      runningTimeTitleLeft: '除湿机运行时间',

      switchTitleRight1: '下游中效过滤堵塞',
      switchTitleRight2: '制备站自动运行',
      switchTitleRight3: '下游送风暂停',
      switchTitleRight4: '空调器运行',

      switchTitleRight5: '下游布袋过滤堵塞',
      switchTitleRight6: '系统报警',
      switchTitleRight7: '热回收堵塞',
      switchTitleRight8: '空调器故障',

      runningTimeTitleRight: '空调器运行时间',

      singleRingDataLeft1: {},
      singleRingDataLeft2: {},
      singleHisDataLeft: {},
      singleRingDataRight1: {},
      singleRingDataRight2: {},
      singleHisDataRight: {},

      switchDataLeft1: {},
      switchDataLeft2: {},
      switchDataLeft3: {},
      switchDataLeft4: {},
      switchDataLeft5: {},
      switchDataLeft6: {},
      switchDataLeft7: {},
      switchDataLeft8: {},
      switchDataRight1: {},
      switchDataRight2: {},
      switchDataRight3: {},
      switchDataRight4: {},
      switchDataRight5: {},
      switchDataRight6: {},
      switchDataRight7: {},
      switchDataRight8: {},
      runningTimeDataLeft: '',
      runningTimeDataRight: '',

      warningFlagLeft: '',
      warningFlagRight: '',
    };
  },
  computed: {
    airWrapTitleLeft() {
      return this.bridgeSegmentName + '上游主缆送风工况';
    },
    airWrapTitleRight() {
      return this.bridgeSegmentName + '下游主缆送风工况';
    },
  },
  created() {
    this.readConfig();
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.resetData();
      this.readConfig();
      this.loadingData = true;
      this.getData();
    },
  },
  methods: {
    readConfig() {
      const routerPath = this.$route.fullPath.split('/');
      this.deviceList = configJson[routerPath[3]].deviceList;
      // const deviceName = configJson[routerPath[3]].deviceName;
      // this.deviceLeftName = deviceName.deviceLeftName;
      // this.deviceRightName = deviceName.deviceRightName;
      this.stationId = configJson[routerPath[3]].stationId;
      this.bridgeSegmentName = configJson[routerPath[3]].bridgeSegmentName;
    },
    resetData() {
      this.warningFlagLeft = '';
      this.warningFlagRight = '';
    },
    refreshData() {
      this.loadingData = true;
      this.getData();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find((el) => {
        return el.deviceName === deviceName;
      });
      if (!device) {
        console.log(`deviceName${deviceName}###`);
      }
      return device.deviceId || '';
    },
    getCurrentData(stationId) {
      return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
    },
    getData() {
      this.getCurrentData(this.stationId).then((res) => {
        setTimeout(() => {
          this.loadingData = false;
        }, 500);

        const currentData = res.data;

        this.setAirWrapData(
          currentData,
          this.deviceIdList,
          '上游送风温度',
          '上游送风风速',
          '上游送风压力',
          '上游送风风机频率',
          '上游送风湿度',
          'singleRingDataLeft1',
          'singleRingDataLeft2',
          'singleHisDataLeft',
          'warningFlagLeft'
        );

        this.setAirWrapData(
          currentData,
          this.deviceIdList,
          '下游送风温度',
          '下游送风风速',
          '下游送风压力',
          '下游送风风机频率',
          '下游送风湿度',
          'singleRingDataRight1',
          'singleRingDataRight2',
          'singleHisDataRight',
          'warningFlagRight'
        );

        const switchIdLeft1 = this.findDeviceId(this.switchTitleLeft1);
        const switchIdLeft2 = this.findDeviceId(this.switchTitleLeft2);
        const switchIdLeft3 = this.findDeviceId(this.switchTitleLeft3);
        const switchIdLeft4 = this.findDeviceId(this.switchTitleLeft4);
        const switchIdLeft5 = this.findDeviceId(this.switchTitleLeft5);
        const switchIdLeft6 = this.findDeviceId(this.switchTitleLeft6);
        const switchIdLeft7 = this.findDeviceId(this.switchTitleLeft7);
        const switchIdLeft8 = this.findDeviceId(this.switchTitleLeft8);

        this.switchDataLeft1 = {
          data: currentData[switchIdLeft1].value,
          isError: currentData[switchIdLeft1].errorLevel,
          isZh: true,
        };
        this.switchDataLeft2 = {
          data: currentData[switchIdLeft2].value,
          isError: currentData[switchIdLeft2].errorLevel,
        };
        this.switchDataLeft3 = {
          data: currentData[switchIdLeft3].value,
          isError: currentData[switchIdLeft3].errorLevel,
          isZh: true,
        };
        this.switchDataLeft4 = {
          data: currentData[switchIdLeft4].value,
          isError: currentData[switchIdLeft4].errorLevel,
        };
        this.switchDataLeft5 = {
          data: currentData[switchIdLeft5].value,
          isError: currentData[switchIdLeft5].errorLevel,
          isZh: true,
        };
        this.switchDataLeft6 = {
          data: currentData[switchIdLeft6].value,
          isError: currentData[switchIdLeft6].errorLevel,
          isZh: true,
        };
        this.switchDataLeft7 = {
          data: currentData[switchIdLeft7].value,
          isError: currentData[switchIdLeft7].errorLevel,
          isZh: true,
        };
        this.switchDataLeft8 = {
          data: currentData[switchIdLeft8].value,
          isError: currentData[switchIdLeft8].errorLevel,
          isZh: true,
        };

        const switchIdRight1 = this.findDeviceId(this.switchTitleRight1);
        const switchIdRight2 = this.findDeviceId(this.switchTitleRight2);
        const switchIdRight3 = this.findDeviceId(this.switchTitleRight3);
        const switchIdRight4 = this.findDeviceId(this.switchTitleRight4);
        const switchIdRight5 = this.findDeviceId(this.switchTitleRight5);
        const switchIdRight6 = this.findDeviceId(this.switchTitleRight6);
        const switchIdRight7 = this.findDeviceId(this.switchTitleRight7);
        // const switchIdRight8 = this.findDeviceId(this.switchTitleRight8);

        this.switchDataRight1 = {
          data: currentData[switchIdRight1].value,
          isError: currentData[switchIdRight1].errorLevel,
          isZh: true,
        };
        this.switchDataRight2 = {
          data: currentData[switchIdRight2].value,
          isError: currentData[switchIdRight2].errorLevel,
        };
        this.switchDataRight3 = {
          data: currentData[switchIdRight3].value,
          isError: currentData[switchIdRight3].errorLevel,
          isZh: true,
        };
        this.switchDataRight4 = {
          data: currentData[switchIdRight4].value,
          isError: currentData[switchIdRight4].errorLevel,
        };
        this.switchDataRight5 = {
          data: currentData[switchIdRight5].value,
          isError: currentData[switchIdRight5].errorLevel,
          isZh: true,
        };
        this.switchDataRight6 = {
          data: currentData[switchIdRight6].value,
          isError: currentData[switchIdRight6].errorLevel,
          isZh: true,
        };
        this.switchDataRight7 = {
          data: currentData[switchIdRight7].value,
          isError: currentData[switchIdRight7].errorLevel,
          isZh: true,
        };
        this.switchDataRight8 = {
          data: 0,
          isError: 0,
          isZh: true,
        };

        const runningTimeIdLeft = this.findDeviceId(
          this.runningTimeTitleLeft,
          this.deviceIdList
        );
        this.runningTimeDataLeft = currentData[runningTimeIdLeft].value;

        const runningTimeIdRight = this.findDeviceId(
          this.runningTimeTitleRight,
          this.deviceIdList
        );
        this.runningTimeDataRight = currentData[runningTimeIdRight].value;
      });
    },

    setAirWrapData(
      currentData,
      deviceIdList,
      singleRingDievceName1A,
      singleRingDievceName1B,
      singleRingDievceName2A,
      singleRingDievceName2B,
      singleHisDeviceName,
      singleRingDataName1,
      singleRingDataName2,
      singleHisDataName,
      errorName
    ) {
      const singleRingDeviceId1A = this.findDeviceId(singleRingDievceName1A);
      const singleRingDeviceId1B = this.findDeviceId(singleRingDievceName1B);
      const singleRingDeviceId2A = this.findDeviceId(singleRingDievceName2A);
      const singleRingDeviceId2B = this.findDeviceId(singleRingDievceName2B);
      const singleHisDeviceId = this.findDeviceId(singleHisDeviceName);

      this[singleRingDataName1] = {
        data1: currentData[singleRingDeviceId1A].value,
        data2: currentData[singleRingDeviceId1B].value,
      };
      this[singleRingDataName2] = {
        data1: currentData[singleRingDeviceId2A].value,
        data2: currentData[singleRingDeviceId2B].value,
      };
      this[singleHisDataName] = {
        data: currentData[singleHisDeviceId].value,
      };

      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleRingDeviceId1A].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleRingDeviceId1B].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleRingDeviceId2A].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleRingDeviceId2B].errorLevel
      );
      this[errorName] = this.getErrorLevelFromMultipleDevice(
        this[errorName],
        currentData[singleHisDeviceId].errorLevel
      );
    },

    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === 'Error') {
        return 'Error';
      } else if (currentErrorLevel === 'Warning') {
        if (newErrorLevel === 'Error') {
          return 'Error';
        } else {
          return 'Warning';
        }
      } else {
        return newErrorLevel;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ventilation {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;

  .device-block-multi {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block {
      width: calc(50% - 10px);
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      position: relative;

      .device-block-line-chart {
        width: 75%;
        height: 100%;
      }

      .device-block-bar-chart {
        width: 24%;
        height: 100%;
      }
    }
  }

  .device-block-line {
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    .device-block-line-item {
      width: calc(50% - 9px);
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      flex-direction: column;
      align-items: stretch;

      .device-block-line-item-half {
        display: flex;
        height: 100%;
        width: calc(50% - 7px);
        flex-direction: column;
        justify-content: space-between;
      }

      .device-block-line-item-top {
        display: flex;
        justify-content: space-between;
        height: 60px;
        width: 100%;
      }

      .switch-item {
        height: 38px;
        width: 100%;
        box-sizing: border-box;
        flex-shrink: 0;
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }

      .running-time-item-left {
        height: calc(100% - 195px);
        width: 100%;
        box-sizing: border-box;
      }

      .running-time-item-right {
        height: calc(100% - 148px);
        width: 100%;
        box-sizing: border-box;
      }

      &.single-chart-item {
        background-color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .air-wrap {
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    width: calc(50% - 10px);
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    box-sizing: border-box;

    .air-title {
      padding: 20px 15px 10px 10px;
      font-size: 22px;
      color: #515151;
    }

    .air-chart-wrap {
      display: flex;
      flex: 1;
    }

    .air-chart {
      padding: 20px 0;
      box-sizing: border-box;
      width: 33.3333%;
    }
  }
}
</style>
